import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from "../lib/axios";

export const getQueryFunction = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const res = await axiosInstance.get(`/query?${params.toString()}`)
        // toast.success("Successfully fetched!");
        console.log("Query", res)
        return res.data.data
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}

export const deleteQuery = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/query/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        return res
    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}